interface Paths {
  [key: string]: string;
}

export default {
  CMS_ROUTE: '*',
  OIDC_SIGNIN: '/signin-oidc',
  SIGNIN: '/login',
  SIGNOUT: '/logout',
  OIDC_SILENT_RENEW: '/signin-oidc-silent',
  OIDC_POST_SIGNOUT_CALLBACK: '/post-signout-callback-oidc',
  OIDC_SIGNOUT_CALLBACK: '/signout-callback-oidc',
  PRODUCT_REDIRECT: '/product/:code',
  PRODUCT_REDIRECT_AUTH: '/product-auth/:code',
  PLUS_CONTENT_REDIRECT_AUTH: '/plus-content-redirect/:code',
  LAUNCHING: '/launching',
  API_ROUTE: '/api/*',
  GLOBAL_ASSETS_ROUTE: '/globalassets/*',
  RSS_ROUTE: '/rss/*',
  SITEMAP_ROUTE: '/sitemap.xml',
  ROBOTS_ROUTE: '/robots.xml',
  CLAIM_CREDIT_REDIRECT: '/claimcredit/:itemPk',
  CREDIT_PLAN_FEEDBACK: '/credit-plan-feedback',
  MARKETING: '/marketing'
} as Paths;
